import UpdateResetPassword from '@nile/banyan/src/Pebbles/update-reset-password/update-reset-password';
import React from 'react';
import { withRouter } from 'react-router-dom';

const UpdatePasswordPage = (props) => {
  return <UpdateResetPassword />;
};

export default withRouter(UpdatePasswordPage);
